// Una scelta a scheda della procedura «Nuova attività» (tela, artboard 41 e 49): icona, titolo e
// una riga che spiega. Fa parte di un `radiogroup`.
import type { ReactNode } from 'react';
import { Icon } from '../../components/Icon';

export function Choice({
  on,
  icon,
  title,
  hint,
  onPick,
}: {
  on: boolean;
  icon?: string;
  title: string;
  hint: ReactNode;
  onPick: () => void;
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={on}
      className="rw-kind rp-choice"
      data-on={on || undefined}
      onClick={onPick}
    >
      <span className="rp-choice-head">
        {icon && <Icon name={icon} size={18} />}
        <span className="t-strong">{title}</span>
      </span>
      <span className="t-small dim">{hint}</span>
    </button>
  );
}
